import React, { useState, useEffect, useCallback } from 'react';
import debounce from 'lodash/debounce';
import ClipLoader from 'react-spinners/ClipLoader';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import 'react-phone-number-input/style.css'
import PhoneInput, { formatPhoneNumber, formatPhoneNumberIntl, isPossiblePhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';

const override = {
  display: 'block',
  margin: '0 auto',
  borderColor: '#EE6C93',
};

const Airport = () => {
  const [startDate, setStartDate] = useState(null);
  const [dateError, setDateError] = useState('');



  const handleStartDateChange = (date) => {
    //console.log(date);
    setStartDate(date);
    setForm({ ...form, date: date });
    setDateError('');
    //setEndDate(null);
  };


  const [isDivVisible, setIsDivVisible] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [passengerCount, setPassengerCount] = useState(1); // Initial passenger count
  const [BagsCount, setBagsCount] = useState(1); // Initial passenger count
  const [valuePhone, setValuePhone] = useState();
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');  
  const [queryFrom, setQueryFrom] = useState('');
  const [queryTo, setQueryTo] = useState('');
  const [resultsFrom, setResultsFrom] = useState([]);
  const [resultsTo, setResultsTo] = useState([]);
  const [selectedFrom, setSelectedFrom] = useState('');
  const [selectedTo, setSelectedTo] = useState('');
  const [loadingFrom, setLoadingFrom] = useState(false);
  const [loadingTo, setLoadingTo] = useState(false);
  const [error, setError] = useState('');
  const [apiError, setApiError] = useState('');
  const [form, setForm] = useState({
    from: '',
    to: '',
    phone: '',
    email: '',
    date: '',
    passengers: '1',
  });
  const [fromError, setFromError] = useState('');
  const [toError, setToError] = useState('');
  const [nameError, setNameError] = useState(''); 
  const [namelastError, setNameLastError] = useState('');

  const [phoneError, setPhoneError] = useState('');
  const [emailError, setEmailError] = useState('');  
  const [passengersError, setPassengersError] = useState('');
  const [bagError, setBagError] = useState('');
  //const [messageError, setMessageError] = useState('');

  const fetchResults = async (searchQuery, setLoading, setResults) => {
    setApiError('');
    setResults([]);
    setLoading(true);
    try {
      const response = await fetch(
        `${airportappLocalizer.apiUrl}/airport/v1/search?code=${searchQuery}`
      );
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      setResults(data);
    } catch (error) {
      setApiError('Failed to fetch data: ' + error.message);
      console.log('Failed to fetch data: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const debouncedFetchResultsFrom = useCallback(
    debounce((searchQuery) => {
      fetchResults(searchQuery, setLoadingFrom, setResultsFrom);
    }, 300), // 300ms delay
    []
  );

  const debouncedFetchResultsTo = useCallback(
    debounce((searchQuery) => {
      fetchResults(searchQuery, setLoadingTo, setResultsTo);
    }, 300), // 300ms delay
    []
  );

  useEffect(() => {
    if (queryFrom.length >= 1) {
      debouncedFetchResultsFrom(queryFrom);
    } else {
      setResultsFrom([]);
    }
  }, [queryFrom, debouncedFetchResultsFrom]);

  useEffect(() => {
    if (queryTo.length >= 1) {
      debouncedFetchResultsTo(queryTo);
    } else {
      setResultsTo([]);
    }
  }, [queryTo, debouncedFetchResultsTo]);

  const handleSuggestionClickFrom = (result) => {
    const selectedText = `${result.air_name} - ${result.air_place} (${result.air_code})`;
    setSelectedFrom(selectedText);
    setQueryFrom(selectedText);
    setResultsFrom([]);
    setForm({ ...form, from: result.air_name });
    setFromError(''); // Clear error on selection
    
  };

  const handleSuggestionClickTo = (result) => {
    const selectedText = `${result.air_name} - ${result.air_place} (${result.air_code})`;
    setSelectedTo(selectedText);
    setQueryTo(selectedText);
    setResultsTo([]);
    setForm({ ...form, to: result.air_name });
    setToError(''); // Clear error on selection
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });

    // Clear the specific error on change
    if (name === 'from') setFromError('');
    if (name === 'to') setToError('');
    if (name === 'phone') setPhoneError('');
    //if (name === 'email') setEmailError('');
    if (name === 'email') {
        if (!value) {
            setEmailError(airportappLocalizer.email_err);
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
            setEmailError(airportappLocalizer.email_err_checking);
        } else {
            setEmailError('');
        }
    } 
    if (name === 'date') setDateError('');
  };

  const validateForm = () => {
    let errors = {};
    if (!form.from) {
      //setQueryFrom('');      
      errors.from = 'From field is required';
      setFromError(airportappLocalizer.from_err);
    }
    if (!form.to) {
      //setQueryTo('');
      errors.to = 'To field is required';
      setToError(airportappLocalizer.to_err);
    }    
    if (!form.phone) {
      errors.phone = 'Phone field is required';
      setPhoneError(airportappLocalizer.phone_err);
    /*} else if (!/^\d{10,13}$/.test(form.phone)) {
      errors.phone = 'Phone number must be between 10 and 13 digits';
      setPhoneError('Phone number must be between 10 and 13 digits');*/
    }

    if (!form.email) {
        errors.email = 'Email field is required';
        setEmailError(airportappLocalizer.email_err);
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
        errors.email = 'Email address is invalid';
        setEmailError(airportappLocalizer.email_err_checking);
    }

    if (!form.date) {
      errors.date = 'Date field is required';
      setDateError(airportappLocalizer.date_err);
    }else{
      setDateError('');
    }  
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      // Handle form submission
      //console.log('Form submitted:', form);
      //console.log('Form submitted stringify:', JSON.stringify(form));
      setLoadingSubmit(true); // Start the loader
        try {
          const response = await fetch(`${airportappLocalizer.apiUrl}/airport/v1/airenquiries`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(form)
          });
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          const data = await response.json();
          console.log('Form submitted:', data);
          setSuccessMessage(data);
          //setSuccessMessage('Thank you! Your enquiry has been submitted successfully.');
          // Optionally clear the form after successful submission
          setForm({
            from: '',
            to: '',
            phone: '',
            email: '',
            date: '',
            passengers: '1',
          });
          setQueryFrom('');
          setQueryTo('');
          setValuePhone('');
          setPhoneError('');
          setStartDate('');
          setPassengerCount(1)
        } catch (error) {
          setError('Failed to submit data: ' + error.message);
          //console.log('Failed to submit data: ' + error.message);
        } finally {
          setLoadingSubmit(false); // Stop the loader
          //setSuccessMessage('');
        }
    }
  };

  const handleBlur = (inputType) => {
    if (inputType === 'from') {
      // Hide the auto-suggestion for 'from' input
      document.body.addEventListener('click', handleBodyClick);
    }
    if (inputType === 'to') {
      // Hide the auto-suggestion for 'to' input
      document.body.addEventListener('click', handleBodyClick);
    }
  };
  
  const handleBodyClick = (event) => {
    // Check if the click target is not within the auto-suggestion list
    if (!event.target.closest('.autosuggestion_from') && !event.target.closest('.autosuggestion_to')) {
      // Perform actions to hide the auto-suggestion
      setResultsFrom([]);
      setResultsTo([]);
      // Remove the event listener to prevent multiple bindings
      document.body.removeEventListener('click', handleBodyClick);
    }
  };
  
  // Function to handle incrementing the passenger count
  const handleIncrement = () => {
      setPassengerCount(prevCount => prevCount + 1);
      setForm({ ...form, passengers: passengerCount + 1 });
  };

  // Function to handle decrementing the passenger count
  const handleDecrement = () => {
      if (passengerCount > 1) {
          setPassengerCount(prevCount => prevCount - 1);
          setForm({ ...form, passengers: passengerCount - 1});
      }
  };

  const handleChange = (phoneNumber) => {
    setValuePhone(phoneNumber);
    if (phoneNumber) {
      if (!isPossiblePhoneNumber(phoneNumber)) {
        setPhoneError(airportappLocalizer.phone_err_checking_length);
        setForm({ ...form, phone: '' });
        //console.log("hello 1"+ phoneNumber);
      } else {
        if(valuePhone && isValidPhoneNumber(phoneNumber)){
          setPhoneError('');
          setValuePhone(phoneNumber);
          setForm({ ...form, phone: phoneNumber });
          //console.log("hello 2"+ phoneNumber);
        }else{
          setPhoneError(airportappLocalizer.phone_err_checking);
          setForm({ ...form, phone: '' });
          //console.log("hello 4"+ phoneNumber);          
        }
        
      }
    } else {
      setPhoneError(airportappLocalizer.phone_err);
      setForm({ ...form, phone: '' });
      //console.log("hello 3"+ phoneNumber);      
    }
  }; 
  

  return (    
    <div className="booking-form-cont moverouge-flight-enquiry">
        <div className="cust-container">            
            <form onSubmit={handleSubmit} autoComplete="off" className="booking-form booking-flight-enquiry-form">
              <div className="search-flight-cont booking-flight-enquiry">
                    <div className="form-inline-cont top-row-fields request-flight-cont">
                      <div class="cust-form-group email-address no-border">
                          <label className="cust-form-label">
                              <img className="btn-icon" src={airportappLocalizer.email_icon} alt="Email Icon" />
                              <span>{airportappLocalizer.email_label}</span>
                          </label>
                          <input
                              className="cust-form-control"
                              autoComplete="new-password"
                              autoCorrect="off"
                              type="email"
                              name="email"
                              value={form.email}
                              onChange={handleInputChange}
                              placeholder={airportappLocalizer.email_placeholder}
                          />
                          {emailError && <div className="error-validation" style={{ color: 'red' }}>{emailError}</div>}
                      </div>
                      <div className="cust-form-group group-date no-border from-date">
                          <label className="cust-form-label">
                              <img className="btn-icon" src={airportappLocalizer.date_icon} alt="Date Icon" />
                              <span>{airportappLocalizer.date_label}</span>
                          </label>
                          <DatePicker
                          name="date"
                          placeholderText={airportappLocalizer.date_placeholder}
                          className="cust-form-control date-input"
                          selected={startDate}
                          onChange={handleStartDateChange}
                          selectsStart
                          startDate={startDate}
                          dateFormat="MMMM d yyyy"
                          minDate={new Date()}
                          />                          
                          {dateError && <div className="error-validation" style={{ color: 'red' }}>{dateError}</div>}
                      </div>
                      <div class="cust-form-group group-phone phone-number no-border">
                          <label className="cust-form-label">
                              <img className="btn-icon" src={airportappLocalizer.phone_icon} alt="Pickup Icon" />
                              <span>{airportappLocalizer.phone_label}</span>
                          </label>
                          <PhoneInput
                              placeholder={airportappLocalizer.phone_placeholder}
                              value={valuePhone}
                              onChange={handleChange}                                
                              international
                              name="phone"
                              countryCallingCodeEditable={true}
                              defaultCountry="GB"
                              error={phoneError}
                          />
                          {phoneError && <div className="error-validation" style={{ color: 'red' }}>{phoneError}</div>}
                      </div>
                      <div className="cust-form-group group-from-to pickup-location no-border">
                        <label for="">
                              <img className="btn-icon" src={airportappLocalizer.from_icon} alt="Pickup Icon" />
                              <span>{airportappLocalizer.from_label}</span>
                          </label>
                        <input
                          className="cust-form-control from-input"
                          autoComplete="off"
                          autoCorrect="off"
                          type="text"
                          name="from"
                          value={queryFrom}
                          onChange={(e) => {
                            setFromError('');
                            setSelectedFrom('');
                            const { value } = e.target;
                            if (e.target.value === '') { 
                              setForm({ ...form, from: '' }); 
                              setQueryFrom('');
                            } else {
                              setQueryFrom(e.target.value);
                            }
                          }}
                          onBlur={() => handleBlur('from')}
                          placeholder={airportappLocalizer.from_placeholder}
                        />
                        {fromError && <div className="error-validation" style={{ color: 'red' }}>{fromError}</div>}
                        {apiError && <div className="error-validation" style={{ color: 'red' }}>{apiError}</div>}
                        <div className={`autosuggestion_from autosuggestion-react ${resultsFrom.length > 0 ? 'active' : ''}`}>
                          {loadingFrom && <ClipLoader color="#EE6C93" cssOverride={{}} size={20} speedMultiplier={1} className="airport_to_loader reactjs_loader" />}
                          <ul>
                            {resultsFrom.map((result) => (
                              <li key={result.air_id} onClick={() => handleSuggestionClickFrom(result)}>
                                <strong>{result.air_name}</strong> - {result.air_place} ({result.air_code})
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                      <div className="cust-form-group group-from-to drop-location no-border">
                          <label for="">
                              <img className="btn-icon" src={airportappLocalizer.to_icon} alt="Drop Icon" />
                              <span>{airportappLocalizer.to_label}</span>
                          </label>
                          <input
                              className="cust-form-control from-input"
                              type="text"
                              autoComplete="off"
                              autoCorrect="off"
                              name="to"
                              value={queryTo}
                              onChange={(e) => {
                              setToError('');
                              setSelectedTo('');
                              const { value } = e.target;
                              if (e.target.value === '') {
                                  setForm({ ...form, to: '' });        
                                  setQueryTo('');
                              } else {
                                  setQueryTo(e.target.value); 
                              }
                              }}
                              onBlur={() => handleBlur('to')}
                              placeholder={airportappLocalizer.to_placeholder}
                          />
                          {toError && <div className="error-validation" style={{ color: 'red' }}>{toError}</div>}
                          {apiError && <div className="error-validation" style={{ color: 'red' }}>{apiError}</div>}
                          <div className={`autosuggestion_to autosuggestion-react ${resultsTo.length > 0 ? 'active' : ''}`}>
                              {loadingTo && <ClipLoader color="#EE6C93" cssOverride={{}} size={20} speedMultiplier={1} className="airport_to_loader reactjs_loader" />}
                              <ul>
                              {resultsTo.map((result) => (
                                  <li key={result.air_id} onClick={() => handleSuggestionClickTo(result)}>
                                  <strong>{result.air_name}</strong> - {result.air_place} ({result.air_code})
                                  </li>
                              ))}
                              </ul>
                          </div>
                      </div>                                              
                      <div className="cust-form-group group-passenger no-border">
                          <label for="">
                              <img className="btn-icon" src={airportappLocalizer.passenger_icon} alt="Passengers Icon" />
                              <span>{airportappLocalizer.passenger_label}</span>
                          </label>
                          <div className="passenger-box">
                              <a className="plus-minus-btn btn-minus" href="javascript:void(0);" onClick={handleDecrement}>
                                  <img className="btn-icon" src={airportappLocalizer.icon_minus} alt="Icon Minus Rounded" />
                              </a>
                              <span className="passenger-count">
                                  <input
                                      type="text"
                                      name="passengers"
                                      value={passengerCount}
                                      onChange={(e) =>{
                                      setPassengerCount(parseInt(e.target.value) || 1);
                                      setForm({ ...form, passengers: parseInt(e.target.value) });
                                      }} // Ensure input value is a number
                                      min="1"
                                  />
                                  {` Passenger${passengerCount > 1 ? 's' : ''}`}
                                  </span>
                              <a className="plus-minus-btn btn-plus" href="javascript:void(0);" onClick={handleIncrement}>
                                  <img className="btn-icon" src={airportappLocalizer.icon_plus} alt="Icon Plus Rounded" />
                              </a>
                          </div>
                      </div>
                    </div> 
                    <div className="cust-form-group moverouge-submit-btn">
                        <input className="common-btn btn-request-flight" type="submit" value={airportappLocalizer.submit_button} />
                        {loadingSubmit && <ClipLoader cssOverride={override} size={50} aria-label="Loading Spinner" data-testid="loader" className="airport_insert_loader reactjs_loader"/>}
                        {successMessage && <span className='submit-success' style={{ color: 'green' }}>{successMessage}</span>}
                        {error && <span className='submit-error' style={{ color: 'red' }}>{error}</span>}
                    </div>


              </div>
            </form>
        </div>
    </div>
  );
};

export default Airport;
